// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerMenu":"Footer_footerMenu__0rtHQ","show":"Footer_show__PZf1J"};